import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations from './mutations';
import state from './state';

import events from './modules/events';
import review from './modules/review';
import stripe from './modules/stripe';
import widget from './modules/widget';

Vue.use(Vuex);
Vue.config.devtools = true;

export const store = new Vuex.Store({
    modules: {
        events,
        review,
        stripe,
        widget,
    },
    state,
    mutations,
    getters,
});
